import BpkRating from '@skyscanner/backpack-web/bpk-component-rating';
import {
  RATING_SCALES,
  RATING_SIZES,
} from '@skyscanner/backpack-web/bpk-component-rating/src/common-types';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { Partner } from '@shared/types/frontend/ubff/hotel-reviews';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './ReviewRating.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

interface ReviewRatingProps {
  logo?: string;
  rating: number;
  partner: Partner;
  i18n: I18nService;
}

const ReviewRating = ({ i18n, logo, partner, rating }: ReviewRatingProps) => {
  const isTa = partner.id === 'h_vs';

  return (
    <BpkRating
      ratingScale={RATING_SCALES.zeroToFive}
      size={RATING_SIZES.base}
      ariaLabel={i18n.translate('rating_info_a11y_label_of_review', {
        rating_value: rating,
        max_rating: 5,
        data_source: partner?.name,
      })}
      className={cls('ReviewRating')}
      title={
        <img
          className={cls(
            'ReviewRating__logo',
            isTa && `ReviewRating__logo--lg`,
            !isTa && 'ReviewRating__logo--sm',
          )}
          alt={partner.name}
          src={
            isTa
              ? 'https://content.skyscnr.com/m/7629f8cf7cf8b3b5/original/h_vs.png'
              : logo
          }
        />
      }
      value={i18n.formatNumber(rating, 1)}
      showScale
    />
  );
};

export default withI18n(ReviewRating);
